import Vue from 'vue'
import VBtn from '../components/vuetify/v-btn'
// import VTextField from '../components/vuetify/extends/v-text-field.vue'
import HsLoading from '../components/ui/HsLoading.vue'
import HsAlert from '../components/ui/HsAlert.vue'
import HsDialog from '../components/ui/HsDialog.vue'
import HsCalendar from '../components/ui/HsCalendar.vue'
import HsCalendarWeek from '../components/ui/HsCalendarWeek.vue'
import HsTimePicker from '../components/ui/HsTimePicker.vue'
import HsDateRange from '../components/ui/HsDateRange.vue'
// import HsDateRangeTest from '../components/ui/HsDateRangeTest.vue' // 임시
import HsImageInput from '../components/ui/HsImageInput.vue'
import HsItemImageInput from '../components/ui/HsItemImageInput.vue'
import HsNoData from '../components/ui/HsNoData.vue'

Vue.component('hs-btn', VBtn)
// Vue.component('hs-text-field', VTextField)
Vue.component('hs-loading', HsLoading)
Vue.component('hs-alert', HsAlert)
Vue.component('hs-dialog', HsDialog)
Vue.component('hs-calendar', HsCalendar)
Vue.component('hs-calendar-week', HsCalendarWeek)
Vue.component('hs-time-picker', HsTimePicker)
Vue.component('hs-date-range', HsDateRange)
// Vue.component('hs-date-range-test', HsDateRangeTest) // 임시
Vue.component('hs-image-input', HsImageInput)
Vue.component('hs-item-image-input', HsItemImageInput)
Vue.component('hs-no-data', HsNoData)
